import React from 'react';
import styled from 'styled-components';
import pt from 'prop-types';
import {useStore} from '../../../stores';

const H1 = styled.h1`
    font-family: ${p => p.theme.fonts.brutal.bold};
    font-size: 3.5em;
    margin: 0 0 3rem;
    color: ${p => p.theme.colors.white || ''};
    &&& {
        ${p =>
            p.loading
                ? `
            height: 3.125rem;
            background: ${p.theme.placeholder.color};
            animation: ${p.theme.placeholder.animation};
            position: relative;
            width: 30rem;
            ${
                p.double
                    ? `
            &:after{
                content: '';
                position: absolute;
                width: 30rem;
                height: 3.125rem;
                background: ${p.theme.placeholder.color};
                top: 4.375rem;
                left: 0;
            }`
                    : ''
            }`
                : ''};
    }
`;

const Title = ({className, title, phDl}) => {
    const [{loading}] = useStore();
    return (
        <H1 className={className} loading={loading} double={phDl}>
            {title}
        </H1>
    );
};

Title.propTypes = {
    title: pt.string,
    phDl: pt.bool,
    className: pt.string
};

export default Title;
